import { Component } from '@angular/core';

@Component({
  selector: 'app-account-profile',
  standalone: false,
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.css']
})
export class AccountProfileComponent {

}
